export enum ColumnNamesEnum {
    myGraphics = 'myGraphics',
    accessory = 'accessory',
    phrase = 'phrase',
    name = 'name',
    tags = 'tags',
    currentDesignGraphics = 'currentDesignGraphics',
    design = 'design',
    dateAdd = 'dateAdd',
}
export const getColumns = (
    t: (key: string) => string
): {
    [key: string]: {
        label: string;
        name: string;
    };
} => {
    return {
        [ColumnNamesEnum.myGraphics]: {
            label: t('My graphics'),
            name: ColumnNamesEnum.myGraphics,
        },
        [ColumnNamesEnum.accessory]: {
            label: t('Accessory'),
            name: ColumnNamesEnum.accessory,
        },
        [ColumnNamesEnum.phrase]: {
            label: t('Search phrase'),
            name: ColumnNamesEnum.phrase,
        },
        [ColumnNamesEnum.name]: {
            label: t('name'),
            name: ColumnNamesEnum.name,
        },
        [ColumnNamesEnum.tags]: {
            label: t('Tags'),
            name: ColumnNamesEnum.tags,
        },
        [ColumnNamesEnum.currentDesignGraphics]: {
            label: t('Used in current design'),
            name: ColumnNamesEnum.currentDesignGraphics,
        },
        [ColumnNamesEnum.design]: {
            label: t('Used in my other design'),
            name: ColumnNamesEnum.design,
        },
        [ColumnNamesEnum.dateAdd]: {
            label: t('Date added'),
            name: ColumnNamesEnum.dateAdd,
        },
    };
};

export const getDateAddLabelValueList = (): {
    label: string;
    value: string;
}[] => [
    {
        label: 'last 7 days',
        value: 'last-7',
    },
    {
        label: 'last 30 days',
        value: 'last-30',
    },
    {
        label: 'last 3 months',
        value: 'last-90',
    },
    {
        label: 'last 6 months',
        value: 'last-180',
    },
    {
        label: 'more then 6 months',
        value: 'more-180',
    },
    {
        label: 'more then 1 year',
        value: 'more-365',
    },
    {
        label: 'more then 2 years',
        value: 'more-730',
    },
];
